// extracted by mini-css-extract-plugin
module.exports = {"Root":"TwoColumns_Root__1bknO"};